// Unfortunately we need to declare everything manually for Parcel to pick those up.

import navSources from '../templates/nav-sources.js';
import navTags from '../templates/nav-tags.js';

export default {
    navSources,
    navTags
};
